import React, { useState, useEffect } from "react";
import "./AddLevel.scss";

export const AddLevel = (props) => {

    const [level, setLevel] = useState(props.level);
    const [maxAccounts, setMaxAccounts] = useState("");
    const [maxEmployees, setMaxEmployees] = useState("");
    const [maxEnterprise, setMaxEnterprise] = useState("");
    const [errMessage, setErrMessage] = useState("");

    async function save(e) {
        e.preventDefault();
        let updatedArray = props.capacityLevels.map(e => e);
        let data = {
            level,
            maxAccounts,
            maxEmployees,
            maxEnterprise
        };
        if (props.isEditData) {
            data._id = props.rowData._id;
            updatedArray.splice(props.rowData.rowIndex, 1, data);
        } else {
            updatedArray.push(data);
        };
        if (!isLevelTaken(level)) {
            await props.save({ capacityLevels: updatedArray })
            props.close()
            props.refreshGrid()
        }
        else return;
    };
    function changeLevel(level) {
        isLevelTaken(level);
        setLevel(level);
    };

    function isLevelTaken(level) {
        let levelTaken = props.capacityLevels.find(el => el.level === level);
        if (levelTaken /* && levelTaken.level !== props.rowData.level */) {
            setErrMessage("Level Number is already in use");
        }
        else setErrMessage("");
        return !!levelTaken;
    };

    function firstAvailLevel() {
        let highest = Math.max(...props.capacityLevels.map(l => l.level));
        for (let i = 1; i++; i === highest + 1) {
            if (!isLevelTaken(i)) return i;
        };
        return highest + 1;
    };

    useEffect(() => {
        initializeData();
    }, [])

    function initializeData() {
        if (props.isEditData) {
            const { level, maxAccounts, maxEmployees, maxEnterprise } = props.rowData
            setLevel(level)
            setMaxAccounts(maxAccounts)
            setMaxEmployees(maxEmployees)
            setMaxEnterprise(maxEnterprise)
        } else setLevel(firstAvailLevel());
    }

    return (
        <div>
            <div className="add_rate_popup cntnt_wrpr">
                <div className="date_column">
                    <label className="fs14">Level</label><br></br>
                    <input type="number" id="txtRole" value={level} onChange={(event) => changeLevel(Number(event.target.value))}  ></input>
                    {errMessage && <p className="error">{errMessage}</p>}
                </div>
                <div className="date_column">
                    <label className="fs14">Max Accounts</label><br></br>
                    <input type="number" id="txtRole" value={maxAccounts} onChange={(event) => setMaxAccounts(Number(event.target.value))}  ></input>
                </div>
                <div>
                    <label className="fs14">Max Enterprise Accounts</label> <br></br>
                    <input type="number" id="txtRole" value={maxEnterprise} onChange={(event) => setMaxEnterprise(Number(event.target.value))}  ></input>
                </div>
                <div className="date_column">
                    <label className="fs14">Max Employees</label> <br></br>
                    <input type="number" id="txtRole" value={maxEmployees} onChange={(event) => setMaxEmployees(Number(event.target.value))}  ></input>
                </div>
                <div className="df acsa ftr">
                    <div className="mla">
                        <button className="mla ttuc fs12 text mini" onClick={() => props.close()}>Cancel</button>
                        <button className="mla ttuc fs12 primary mini"
                            onClick={save} disabled={errMessage}>Save
                        </button>
                    </div>
                </div>
            </div>
        </div>

    );
};
